import { useCallback } from 'react'
import { useQueryClient } from 'react-query'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { calendarKeys } from 'hooks/queries/calendar/calendarKeys'

export const useRefreshIntegrationConnection = () => {
  const { initiateOauth } = useInitiateOauth()
  const { connect: connectAccountPopup } = useConnectAccountPopup()
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()

  return useCallback(
    async (provider: ExternalIntegrationEnum, integrationId?: number) => {
      const popup = await initiateOauth(provider, integrationId, '_blank', 'popup=true,width=600,height=780')
      if (!popup) return
      connectAccountPopup(popup as Window, {
        onConnect: () => {
          queryClient.invalidateQueries(calendarKeys.all)
          queryClient.invalidateQueries(['externalIntegrations', workspaceId])
        },
      })
    },
    [initiateOauth, connectAccountPopup, queryClient, workspaceId],
  )
}
